import { render, staticRenderFns } from "./PartnersInquiryPage.vue?vue&type=template&id=1934a38f&"
import script from "./PartnersInquiryPage.vue?vue&type=script&lang=js&"
export * from "./PartnersInquiryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports